import { Link } from 'react-router-dom';
import { ShieldOff } from 'lucide-react';

export default function AccessDenied() {
  return (
    <div className="mx-auto flex min-h-[50vh] max-w-lg flex-col items-center justify-center px-6 text-center">
      <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-red-50 text-red-600">
        <ShieldOff className="h-6 w-6" />
      </div>
      <h1 className="text-xl font-semibold text-gray-900">Accès refusé</h1>
      <p className="mt-2 text-sm text-gray-600">
        Vous n’avez pas la permission d’ouvrir cette page. Le serveur refuse aussi l’action correspondante.
      </p>
      <Link
        to="/"
        className="mt-6 rounded-xl bg-gray-900 px-4 py-2 text-sm font-medium text-white"
      >
        Retour à l’accueil
      </Link>
    </div>
  );
}
